<template>
  <div class="sales-card">
    <div class="sales-icon">
      <i class="fas fa-chart-line"></i>
    </div>
    <div class="sales-content">
      <h2 class="sales-title">Total sales this month</h2>
      <div class="sales-amount">${{ salesAmount }}</div>
      <router-link to="/dashboard/gift-card-sales" class="view-previous-link">
        View Previous Months
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalSales',
  props: {
   salesAmount: String,
  }
};
</script>

<style scoped>
.sales-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  flex: 1;
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
}

.sales-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.sales-icon {
  background-color: #4C6B30;
  color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-right: 1.5rem;
}

.sales-content {
  display: flex;
  flex-direction: column;
}

.sales-title {
  font-size: 1.1rem;
  color: #666;
  margin: 0 0 0.5rem 0;
  font-weight: normal;
}

.sales-amount {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
}

.view-previous-link {
  margin-top: 0.5rem;
  color: #4C6B30;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  display: inline-block;
  transition: color 0.2s;
}

.view-previous-link:hover {
  color: #6E9F49;
  text-decoration: underline;
}

/* Media Queries for responsiveness */
@media (max-width: 768px) {
  .sales-card {
    padding: 1.25rem;
  }
  
  .sales-icon {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
    margin-right: 1rem;
  }

  .sales-title {
    font-size: 1rem;
  }

  .sales-amount {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .sales-card {
    padding: 1rem;
    flex-direction: column;
    text-align: center;
  }

  .sales-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .sales-title {
    font-size: 0.9rem;
  }

  .sales-amount {
    font-size: 1.2rem;
  }
}
</style>
